//

import { normalize } from 'normalizr';
import moment from 'moment';
import { browserHistory } from 'react-router';

import { simplApi } from '../../api/simplApi';

import { company } from './schemas';

import { receiveActivity } from './activity';
import { receivePerson } from './person';
import { receiveStaff } from './staff';
import { receiveProject } from './project';
import { receiveFile } from './file';
import { receiveTask } from './task';
import { dateFormat } from '../../helpers/formats';
import { fetchTotalData } from './totaldata';
import handleApiError from '../../helpers/handleApiError';
import { addFeedback } from './feedback';

const _ = require('lodash');

// ------------------------------------
// Constants
// ------------------------------------
export const REQUEST_COMPANY = 'REQUEST_COMPANY';
export const RECEIVE_COMPANY = 'RECEIVE_COMPANY';
export const SET_COMPANY = 'SET_COMPANY';
export const SET_COMPANY_FORM = 'SET_COMPANY_FORM';
export const CLOSE_COMPANY_FORM = 'CLOSE_COMPANY_FORM';
export const REMOVE_COMPANY = 'REMOVE_COMPANY';

// ------------------------------------
// Actions
// ------------------------------------

export function requestCompany() {
  return {
    type: REQUEST_COMPANY,
  };
}

export function receiveCompany(companies) {
  return {
    type: RECEIVE_COMPANY,
    payload: {
      companies,
    },
  };
}

export function setCompany(companyId) {
  // // console.log('action setCompany', companyId);
  return {
    type: SET_COMPANY,
    payload: companyId,
  };
}

export function setCompanyForm(companyId = '') {
  return {
    type: SET_COMPANY_FORM,
    payload: companyId,
  };
}

export function closeCompanyForm() {
  return {
    type: CLOSE_COMPANY_FORM,
  };
}

export const fetchCompany = companyId => dispatch => {
  dispatch(requestCompany());

  const url =
    typeof companyId !== 'undefined' && companyId !== null
      ? `company/${companyId}`
      : 'company';

  return simplApi(url)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        dispatch(handleApiError(json));
      } else {
        let preparedCompanies;

        if (typeof json.id === 'undefined') {
          preparedCompanies = normalize(json, [company]);
        } else {
          preparedCompanies = normalize(json, company);
        }

        // // console.log('prepping comps', preparedCompanies);
        //
        dispatch(receiveCompany(preparedCompanies.entities.companies));
        dispatch(receiveActivity(preparedCompanies.entities.activities));
        dispatch(receivePerson(preparedCompanies.entities.persons));
        dispatch(receiveStaff(preparedCompanies.entities.staff));
        dispatch(receiveFile(preparedCompanies.entities.files));
        dispatch(receiveTask(preparedCompanies.entities.tasks));
        dispatch(receiveProject(preparedCompanies.entities.projects));
      }
    });
};

export function removeCompany(companyId) {
  return {
    type: REMOVE_COMPANY,
    payload: companyId,
  };
}

export const deleteCompany = companyId => dispatch => {
  const url = `company/${companyId}`;
  const options = { method: 'delete' };

  return simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        dispatch(handleApiError(json));
      } else {
        dispatch(removeCompany(companyId));
        dispatch(addFeedback('warning', 'Unternehmen gelöscht'));
      }
    });
};

export const saveCompany = (newCompany, redirect = true) => dispatch => {
  // console.log('attempting to save an company!');

  dispatch(requestCompany());

  let url = 'company/';
  const options = { method: 'post', body: newCompany };
  if (typeof newCompany.id !== 'undefined' && newCompany.id !== null) {
    url = `${url}${newCompany.id}`;
    options.method = 'put';
  }

  return simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        dispatch(handleApiError(json));
      } else {
        const preparedCompanies = normalize(json, company);

        dispatch(receiveCompany(preparedCompanies.entities.companies));
        dispatch(receiveFile(preparedCompanies.entities.files));

        dispatch(addFeedback('success', 'Unternehmen gespeichert'));

        dispatch(fetchTotalData());

        if (redirect) {
          browserHistory.push(`/company/${json.id}`);
        } else {
          return json;
        }
      }
    });
};

export const actions = {
  requestCompany,
  receiveCompany,
  fetchCompany,
  setCompany,
  setCompanyForm,
  closeCompanyForm,
  saveCompany,
  deleteCompany,
  removeCompany,
};

const COMPANY_ACTION_HANDLERS = {
  [REQUEST_COMPANY]: state => ({
    ...state,
    fetching: true,
  }),
  [SET_COMPANY]: (state, action) => ({ ...state, current: action.payload }),
  [SET_COMPANY_FORM]: (state, action) => ({
    ...state,
    formOpen: true,
    formTarget: action.payload,
  }),
  [REMOVE_COMPANY]: (state, action) => ({
    ...state,
    companies: _.omit(state.companies, action.payload),
  }),
  [CLOSE_COMPANY_FORM]: state => ({
    ...state,
    formOpen: false,
    formTarget: null,
  }),
  [RECEIVE_COMPANY]: (state, action) => {
    const stateCompanies = state.companies;

    _.forOwn(action.payload.companies, (_company, id) => {
      const newCompany = _company;
      const newMeta = {};

      _.forOwn(_company.meta, value => {
        newMeta[value.key] = value;
      });

      newCompany.meta = newMeta;

      newCompany.createdDate = moment(_company.created_at).format(dateFormat);

      if (typeof stateCompanies[id] === 'object') {
        stateCompanies[id] = Object.assign(
          {},
          stateCompanies[id],
          stateCompanies[id],
          newCompany,
        );
      } else {
        stateCompanies[id] = newCompany;
      }
    });

    return {
      ...state,
      companies: stateCompanies,
      fetching: false,
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  current: null,
  formOpen: false,
  formTarget: null,
  fetching: false,
  companies: {},
};
export default function companyReducer(state = initialState, action) {
  const handler = COMPANY_ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/modules/company.js